<template>
  <div v-loading="loading"  element-loading-background="rgba(0, 0, 0, 0.8)">
    <div >
      <div>
        <el-button type="primary" @click="showPopup"  class="all_text">添加</el-button>
        <el-dialog :visible.sync="dialogVisible" width="40%">
          <el-input v-model="inputValue" placeholder="登录名"   class="input_box"></el-input>
          <el-input v-model="inputValue1" placeholder="真名"    class="input_box"></el-input>
          <el-input v-model="inputValue2" placeholder="密码"    class="input_box"></el-input>
          <span slot="footer" class="dialog-footer">
            <el-button @click="clear_box">取 消</el-button>
            <el-button type="primary" @click="saveInput">确 定</el-button>
          </span>
        </el-dialog>
      </div>
      <div >
        <el-table   class="copy"  ref="sortTable" :data="tableData" :cell-style="rowStyle" :summary-method="getSummaries" height="55%"
        empty-text="正在加载数据中..."  @sort-change="sortChangeEvt" show-summary style="width: 100%;  overflow: none">
          <!-- <el-table-column type="vlo" width="55"> </el-table-column> -->
          <el-table-column  prop="realname" sortable="custom"   width="120" label="昵称" height="250"  align="left">
          </el-table-column>

          <el-table-column sortable="custom" prop="is_active" label="有效性" width="120" align="left">
            <template slot-scope="props">
              <div>
                <el-dropdown trigger="click" @command="activeEvt">
                  <span class="el-dropdown-link" @click="activeTextEvt(props.row)">
                    {{ props.row.is_active
                    }}<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :disabled="props.row.is_active == '有效'" command="1">有效</el-dropdown-item>
                    <el-dropdown-item :disabled="props.row.is_active == '无效'" command="2">无效</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>



          <el-table-column  prop="realname" sortable="custom"  width="120" label="会员情况" align="left">
          </el-table-column>
          <el-table-column  prop="role"     sortable="custom"  width="120" label="角色" align="left">
          </el-table-column>
          <el-table-column  prop="username"  sortable="custom"  width="120"  label="用户名称" align="left">
          </el-table-column>
          <el-table-column  prop="update_time"  width="160"  sortable="custom"  label="最后访问时间" align="left">
          </el-table-column>
          <el-table-column  prop="ip"  label="访问IP"  sortable="custom"  align="left">
          </el-table-column>



        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
  import { AdminListApi, EditApi , AddoneApi } from "../../../apis/user/index";
  export default {
    data() {
      return {
        header: true,
        src: "https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg",
        //备注
        remtInput: "",
        authorIdInput: "",
        localInput: "",
        //分页输入框数据
        paginationInput: 10,
        currentPage1: 1,
        //分页总数据
        total: null,
        pickerOptions: {
          shortcuts: [
            {
              text: "今天",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                picker.$emit("pick", [start, end]);
              },
            },
            {
              text: "本周",
              onClick(picker) {
                const current = new Date();
                let nowDayOfWeek = current.getDay();
                if (nowDayOfWeek === 0) nowDayOfWeek = 7;
                const dayNum = 1 * 24 * 60 * 60 * 1000;
                const firstDate = new Date(current.valueOf() - (nowDayOfWeek - 1) * dayNum);
                const lastDate = new Date(new Date(firstDate).valueOf() + 6 * dayNum);
                picker.$emit("pick", [firstDate, lastDate]);
              },
            },
            {
              text: "当月",
              onClick(picker) {
                const date = new Date();
                const year = date.getFullYear();
                const month = date.getMonth();
                let thisMonthStartDate = new Date(year, month, 1);
                let thisMonthEndDate = new Date(year, month + 1, 0);
                picker.$emit("pick", [thisMonthStartDate, thisMonthEndDate]);
              },
            },
            {
              text: "当年",
              onClick(picker) {
                var tYear = new Date().getFullYear();
                var startTime = new Date(tYear, 0, 1); //当前年第一天
                var endTime = new Date(tYear, 11, 31); //当前年最后一天
                picker.$emit("pick", [startTime, endTime]);
              },
            },
            {
              text: "昨天",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                picker.$emit("pick", [start, start]);
              },
            },
            {
              text: "上周",
              onClick(picker) {
                const current = new Date(new Date().getTime() - 60 * 60 * 24 * 7 * 1000);
                let nowDayOfWeek = current.getDay();
                let diffToMonday =
                  current.getDate() - nowDayOfWeek + (nowDayOfWeek === 0 ? -6 : 1);
                const firstDate = new Date(current.setDate(diffToMonday));
                const lastDate = new Date(current.setDate(diffToMonday + 6));
                picker.$emit("pick", [firstDate, lastDate]);
              },
            },
            {
              text: "上月",
              onClick(picker) {
                var now = new Date();
                var fd = new Date(now.getFullYear(), now.getMonth() - 1, 1);
                var ed = new Date(now.getFullYear(), now.getMonth(), 0);
                picker.$emit("pick", [fd, ed]);
              },
            },
            {
              text: "去年",
              onClick(picker) {
                var tYear = new Date().getFullYear() - 1;
                var startTime = new Date(tYear, 0, 1);
                var endTime = new Date(tYear, 11, 31); //当前年最后一天
                picker.$emit("pick", [startTime, endTime]);
              },
            },
          ],
        },
        value2: "",
        adminuser: null,
        member: null,
        effectiveName: "有效性",
        okAndNo: null,
        laiyuan: null,
        input: "",
        editShowInp: null,
        editName: null,
        tableData: [],
        totalRow: null,
        //排序
        order: null,
        orField: null,
        activeId: null,
        showForm: false,
        data: {},
        num: null,
        count: 0,
        pagefenye: false,//点击分页 滚动条为0
        loading: false,
        isValue2Empty: true,
        isValue2Empty_box:true,

        dialogVisible: false,
        inputValue: '',
        inputValue1: '',
        inputValue2: '',
        c:1,
      };
    },
    created() {
        this.loading = true
    if (this.$store.getters.location == '') {
      this.c = 1
    }
    this.c = this.$store.getters.location;

      AdminListApi({c:this.c}).then((res) => {
        this.tableData = res.data.admin;
        this.paginationInput = res.limit;
        this.currentPage1 = res.page - 0;
        this.total = res.total;
        this.totalRow = res.totalRow;
        this.loading = false
      });
      //监听鼠标按下抬起事件
      window.addEventListener("keydown", this.handKeyCode, true);
      window.addEventListener('keyup', this.handKeyEvt);
    },
    beforeDestroy() {
      // 在组件生命周期结束的时候销毁
      window.removeEventListener("keydown", this.handKeyCode, false);
      window.removeEventListener("keyup", this.handKeyEvt, false);
    },
    mounted() {
      //监听页面滚动条事件
      window.addEventListener("scroll", (e) => this.imgScrollEvt(e), true);
      const ellipsis = document.querySelector('.ellipsis');
      this.c = this.$store.getters.location;
    },
    methods: {
      //等级
      tableLevelEvt(res) {
        this.num = res
        this.deleteVisible = true
      },
      showPopup() {
      this.dialogVisible = true;
      },
      clear_box(){
          this.dialogVisible = false;
          this.inputValue  = '' ;
          this.inputValue1 = '';
          this.inputValue2 = '';
      },
      saveInput() {
        if (!this.inputValue) {
          this.$message.error('请输入登录名');
          return;
        }

        if (!this.inputValue1) {
          this.$message.error('请输入真名');
          return;
        }

        if (!this.inputValue2) {
          this.$message.error('请输入密码');
          return;
        }
        AddoneApi({
          username:this.inputValue,
          realname:this.inputValue1,
          password:this.inputValue2,
          c: this.c,
        }).then((res) => {
             if( res.code == 1000 ){
              AdminListApi({c:this.c}).then((res) => {
                  this.tableData = res.data.admin;
                  this.inputValue  = '';
                  this.inputValue1 = '';
                  this.inputValue2 = '';
                  this.dialogVisible = false;
                });
             }
        });

      },


      //分页只显示前三页加总数
      showTotal(total) {
        return `共 ${total} 页`;
      },

      //按下键盘事件
      handKeyCode(e) {
        e = e || window.event;
        if (e.keyCode == 78) {
          this.cleanUpEvt()
        }
        if (e.keyCode == 70) {
          this.count++;
          if (this.count == 1) {
            this.showForm = true
          } else {
            this.showForm = false
          }
          setTimeout(() => {
            this.count = 0;
          }, 500);
        }
      },

      limitEvt() {
        this.getList();
      },
      //滑动事件
      imgScrollEvt(e) {
        var e =
          document.documentElement.scrollTop ||
          window.pageYOffset ||
          e ||
          document.body.scrollTop;
        //点击分页 滚动条为0
        if (this.pagefenye == true) {
          e.scrollTop = 0;
          this.pagefenye = false
          return
        }
        var scrollTop = e.target.scrollTop;
        let scrollStep = scrollTop - this.oldScrollTop;
        this.oldScrollTop = scrollTop;
        var scrollLeft = e.target.scrollLeft;
        let scrollLeftStep = scrollLeft - this.oldScrollLeft;
        this.oldScrollLeft = scrollLeft;

        if (scrollLeft > 0 && scrollTop == 0) {
          this.header = true;
          this.$store.dispatch("setShowHeader", this.header);
          return;
        }
        if (scrollTop <= 0) {
          this.header = true;
          this.$store.dispatch("setShowHeader", this.header);
          return;
        }
        if (scrollStep == 0) {
          this.header = true;
          this.$store.dispatch("setShowHeader", this.header);
          return;
        }
        if (scrollStep < 0) {
          this.header = true;
          this.$store.dispatch("setShowHeader", this.header);
        } else {
          this.header = true;
          this.$store.dispatch("setShowHeader", this.header);
        }
      },
      //分页
      handleCurrentChange(res) {
        this.loading = true
          setTimeout(()=>{
           this.getList()
           this.loading = false
          },100)
      },
      //
      rowStyle({ row, column, rowIndex, columnIndex }) {
        if (column.label == "等级") {
          return {};
        } else if (column.label == "昵称") {
          return {};
        }
      },
      //列表排序
      sortChangeEvt(sort) {
        const prop = sort.prop;
        const order = sort.order;
          this.tableData.sort((a, b) => {
            const valueA = String(a[prop]);
            const valueB = String(b[prop]);
            let result = valueA.length - valueB.length;
            if (order === 'descending') {
              result = -result;
            }
            return result;
          });
      },
      //显示修改输入框
      editShowEvt(e, s) {
        this.editShowInp = e.id;
        this.editName = s;
        this.$nextTick((_) => {
          this.$refs.editInput.$refs.input.focus();
        });
      },


      getSummaries(param) {
        const { columns} = param;
        const sums = [];
        columns.forEach((column, index) => {
          for (let key in this.totalRow) {
            if (column.property == key) {
              sums[index] = this.totalRow[key];
            }
          }
          if (index === 0) {
            sums[index] = "";
            return;
          }
        });
        return sums;
      },


      activeEvt(res) {
        let str = "";
        if (res == 1) {
          str = "有效";
        } else {
          str = "无效";
        }
        EditApi({
          id: this.activeId,
          field: "is_active",
          val: res,
          c:this.c,
        }).then((e) => {
          this.tableData = this.tableData.map((val) => {
            if (val.id == this.activeId) {
              val.is_active = str;
            }
            return val;
          });
        });
      },

      activeTextEvt(res) {
        this.activeId = res.id;
      },
      //获取页面数据
      getList() {
        let data = {
          orField: this.orField,
          orWhere: this.order,
          remt: this.remtInput,
          authorId: this.authorIdInput,
          local: this.localInput,
          on_time: this.value2[0],
          start_time: this.value2[1],
          okAndNo: this.okAndNo,
          adminuser: this.adminuser,
          member: this.member,
          laiyuan: this.laiyuan,
          page: this.currentPage1,
          limit: this.paginationInput,
          c:this.c
        };
        AdminListApi(data).then((res) => {
          this.tableData = res.data;
          this.paginationInput = res.limit;
          this.currentPage1 = res.page - 0;
          this.total = res.total;
          this.totalRow = res.totalRow;
          this.pagefenye = true;  //点击分页 滚动条为0
          let as = document.querySelector('.el-table__body-wrapper')
          as.scrollTop = 0
          this.imgScrollEvt(as)
        });

      },
      //清除搜索条件
      cleanUpEvt() {
        this.value2 = "";
        this.okAndNo = null;
        this.adminuser = null;
        this.member = null;
        this.laiyuan = null;
        this.currentPage1 = 1;
        this.orField = null;
        this.order = null;
        this.remtInput = "";
        this.authorIdInput = "";
        this.localInput = "";
        this.last_logi = "";
        this.effectiveName = "有效性";
        this.$refs.sortTable.clearSort();
        AdminListApi({c:this.c}).then((res) => {
          this.tableData = res.data;
          this.paginationInput = res.limit;
          this.currentPage1 = res.page - 0;
          this.total = res.total;
          this.totalRow = res.totalRow;
        });
      },
      OK_Pop() {
        this.getList()
        const form = document.getElementById('form');
        const closeBtn = document.getElementById('close-btn');
        closeBtn.addEventListener('click', function () {
          form.style.display = 'none';
        });
      },
      clearEvt1() {
      this.remtInput = '';
        this.clear()
      },
      clearEvt2() {
     this.authorIdInput  = '';
        this.clear()
      },
      clearEvt3() {
         this.localInput  ;
        this.clear()
      },
      //选中后内容点击X清除内容并刷新数据
      clear(){
        AdminListApi({c:this.c}).then((res) => {
          this.tableData = res.data;
          this.paginationInput = res.limit;
          this.currentPage1 = res.page - 0;
          this.total = res.total;
          this.totalRow = res.totalRow;
        });
      },
    },
    //点击X后清理数据后并更改值
    computed: {
    },
    watch: {
       '$store.getters.location': function (newLocation, oldLocation) {
      this.c = newLocation
    },
        //修改选中日期的背景颜色
      'value2': function (newVal, oldVal) {
        this.isValue2Empty = !newVal;
      },
    }
  };
</script>

<style lang="less"  scoped>
  @import url("../../../style/space.less");


  .item {
    margin-top: 10px;
  }

  /deep/.el-main {
    overflow: unset !important;
  }

  .search_box {
    position: fixed;
    top: 60px;
    height: 90px;
    border-radius: 10px;
    background-color: #fff;
    width: calc(100% - 10%);
    /*visibility: hidden;*/
    .num_box {
      width: 127px;
      border: 1px solid #e4e3e3;
      border-radius: 3px;
      margin-top: 5px;
    }
  }
  .search_box {
      width: 980px;
      /* 其他样式设置 */
    }
  .all_text {
    background-color: #409eff;
    font-size: 13px;
    color: #fff;
    cursor: pointer;
    padding: 5px 20px;
    border-radius: 3px;
    margin-left: 10px;
  }

  .caoz {
    margin-top: 8px;
    display: flex;
  }

  /* .block {
    position: absolute;
    margin-top: 9px;
    top: 0;
    right: 1%;
    transition: all 0.2s ease 0.5s;
  } */
  .block{
      position: fixed;
      right: calc(100% - 99.4%);
      top: 60px;
   }

  .block1 {
    visibility: hidden;
  }

  .block1>div {
    display: none;
  }

  .clear {
    position: relative;
    height: 50px;

    span:nth-last-child(1) {
      background-color: #fff;
      border: 1px solid #e5e5e5;
      font-size: 13px;
      color: #c4c3c3;
      border-radius: 3px;
      position: absolute;
      right: 5px;
      bottom: -6px;
      padding: 0 10px;
      cursor: pointer;
    }

  }


  .demo-table-expand {
    background-color: #f2f2f2;
    font-size: 0;
  }

  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }

  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    padding: 0 20px;
    width: 30%;
  }

  .name_box {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;

    i {
      cursor: pointer;
      display: none;
    }
  }

  .name_box:hover>i {
    display: block;
  }

  .pagination_box {
    min-width: 500px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .num_box button {
    width: 125px;
    border: none;
    background-color: #fff;
    color: #c4c3c3;
  }



  .rowClassOne {
    background-color: #e7ecff;
  }

  .rowClassTwo {
    color: #222222;
    background-color: #1c43ce;
  }

  .rowClassThree {
    background-color: #6a88f1;
  }

  .el-dropdown-link {
    cursor: pointer;
  }

  .notes_box {
    height: 72px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .my-icon {
    cursor: pointer;
    width: 25px;
  }

  /deep/.el-table thead {
    font-size: 12px;
  }
  /deep/.el-table__fixed-footer-wrapper {
    display: none;
  }

  /deep/.el-badge__content.is-fixed {
    display: none;
  }

  /deep/.el-input__inner {
    color: #409eff;
    cursor: pointer;
  }

  .clear_ev {
    position: absolute;
    right: 10px;
  }

  .vip-button {
    color: #000 !important;
    background-color:#bcd9f8d4 !important  ;
  }
  .sup{
        position: absolute;
        top: -3px;
        right: -5px;
        transform: translateY(-50%) translateX(100%);
        padding: 0px 4px 0px 5px;
        background: rgb(255, 0, 0);
        border-radius: 50%;
        color: rgb(255, 255, 255);
        font-size: 12px;
        transform: scale(0.8)
  }

  .ellipsis {
      /* 其他样式设置 */
      cursor: pointer;
      color: blue;
    }

   /* 朝上排序样式 */
   /deep/.el-table .ascending .sort-caret.ascending{
    background-color: #f00 !important;
    background: url("../../../img/12.png" )no-repeat  -4px -3px  !important;
    background-size: 11px 14px !important;
    width: 40px;
    height: 58px;
    z-index: 11;
  }
  /* 朝下排序样式 */
  /deep/.el-table .descending .sort-caret.descending{
    background: url("../../../img/22.png" )no-repeat -5px 2px  !important;
    background-size: 11px 14px !important;
    width: 40px;
    height: 25px;

  }
  /deep/.el-table .descending .sort-caret.descending{
    border-top-color: #fff;
  }
   /* 朝上字体样式 */
   /deep/.el-table__header .ascending  .cell{
    color: #409EFF !important;
  }
  /* 朝下字体样式 */
  /deep/.el-table__header .descending  .cell{
    color: #409EFF !important;
  }

  .your-css-class{
    background-color: #bcd9f8d4  !important;
    z-index: 9999;
    input{
      background-color:#bcd9f8d4  !important;
    }
  }
  .your-css-class_box{
    background-color: #bcd9f8d4  !important;
    input{
      background-color: #bcd9f8d4 !important;
    }
  }

  .orange{
    /deep/.el-input__inner{
      background-color: #bcd9f8d4 !important;
      color: #222222;
    }
    /deep/.el-input__suffix{
      color: #222222;
    }
  }
  /deep/.el-table__body-wrapper{
    height: calc(100vh - 103px) ;
    overflow-y: scroll;
  }

  .input_box{
    border:1px solid  #d1d1d1;
    margin: 10px 0;
  }

</style>
<style>
  .your-css-class .el-range-input{
    background-color: #8fc6ff00 !important;
  }
  .your-css-class_box  .el-range-input{
    background-color: #8fc6ff00 !important;
  }

</style>



// WEBPACK FOOTER //
// src/user/components/background/index.vue